export const experienceData = [
    {
        id: 1,
        company: 'Microsoft',
        jobtitle: 'Microsoft Learn Student Ambassador',
        startYear: '2023',
        endYear: 'present'
    },
    {
        id: 2,
        company: 'Google and TalentSprint',
        jobtitle: 'Women Techmakers Engineering Fellow',
        startYear: '2021',
        endYear: '2022'
    },
    {
        id: 3,
        company: 'SCSE',
        jobtitle: 'Graphic Designer',
        startYear: '2021',
        endYear: '2022'
    },
]